export class Schooling {
    name: string;
    id: number;
    code: string;
}